//手牌位置节点
const {ccclass, property} = cc._decorator;

@ccclass
export class handNode extends cc.Component{
    @property([cc.Node])
    nodeList: cc.Node[] = []

    protected mTransformDataList: any[] = null
    init(){
        //处理适配
        if (true) {
            this.mTransformDataList = []
            for (let index = 0; index < this.nodeList.length; index++) {
                const node = this.nodeList[index];
                let data: any = {}
                data.localPos = node.position
                data.worldPos = node.parent.convertToWorldSpaceAR(node.position)
                data.angle = node.angle + node.parent.angle
                data.scale = node.scale * node.parent.scale
                let zIndex = 0
                 for (let i = 0; i < node.parent.childrenCount; i++) {
                     const element = node.parent.children[i];
                     if(element == node){
                         zIndex = i
                         break
                     }
                 }
                 data.zIndex = zIndex
                 this.mTransformDataList.push(data)
            }
        }
    }

    get transformDataList(){
        this.init();
        return this.mTransformDataList
     }
}